// Índice de traducciones en español
import { commonEs } from './common';
import { formsEs } from './forms';
import { navigationEs } from './navigation';
import { vehiclesEs } from './vehicles';
import { pagesEs } from './pages';
import { homeEs } from './home';
import { footerEs } from './footer';
import { financingEs } from './financing';
import { consignmentsEs } from './consignments';
import { buyDirectEs } from './buyDirect';
import { weSearchForYouEs } from './weSearchForYou';
import { contactEs } from './contact';
import { aboutEs } from './about';
import { bookingEs } from './booking';
import { formsUiEs } from './formsUi';
import { catalogEs } from './catalog';
import { siteEs } from './site';

export const es = {
  common: commonEs,
  forms: formsEs,
  navigation: navigationEs,
  vehicles: vehiclesEs,
  home: homeEs,
  pages: pagesEs,
  footer: footerEs,
  financing: financingEs,
  consignments: consignmentsEs,
  buyDirect: buyDirectEs,
  weSearchForYou: weSearchForYouEs,
  contact: contactEs,
  about: aboutEs,
  booking: bookingEs,
  formsUi: formsUiEs,
  catalog: catalogEs,
  site: siteEs,
};
